var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoCircleFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_396_456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.16429 0 0 7.16429 0 16C0 24.8357 7.16429 32 16 32C24.8357 32 32 24.8357 32 16C32 7.16429 24.8357 0 16 0ZM17.1429 23.7143C17.1429 23.8714 17.0143 24 16.8571 24H15.1429C14.9857 24 14.8571 23.8714 14.8571 23.7143V14C14.8571 13.8429 14.9857 13.7143 15.1429 13.7143H16.8571C17.0143 13.7143 17.1429 13.8429 17.1429 14V23.7143ZM16 11.4286C15.5514 11.4194 15.1243 11.2348 14.8103 10.9143C14.4962 10.5938 14.3204 10.163 14.3204 9.71429C14.3204 9.2656 14.4962 8.83478 14.8103 8.51429C15.1243 8.19379 15.5514 8.00916 16 8C16.4486 8.00916 16.8757 8.19379 17.1898 8.51429C17.5038 8.83478 17.6796 9.2656 17.6796 9.71429C17.6796 10.163 17.5038 10.5938 17.1898 10.9143C16.8757 11.2348 16.4486 11.4194 16 11.4286Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_396_456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleFilled);
export default __webpack_public_path__ + "static/media/InfoCircleFilled.8b61469004ca66dc4db8b88ed15d1ddc.svg";
export { ForwardRef as ReactComponent };